import { LOCALE_ID, NgModule, isDevMode } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import { LoginComponent } from './components/Authentication/login/login.component';

import { ProfileComponent } from './components/core/profile/profile.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ResigteringComponent } from './components/Authentication/resigtering/resigtering.component';
import {
  HTTP_INTERCEPTORS,
  HttpClient,
  HttpClientModule,
} from '@angular/common/http';
import { HeaderComponent } from './shared/header/header.component';
import { HeaderMobileComponent } from './shared/header.mobile/header.mobile.component';
import { FooterComponent } from './shared/footer/footer.component';
import { VerificationCodeComponent } from './components/Authentication/verification-code/verification-code.component';
import { TokenInterceptor } from './interceptors/token.interceptor';
import { LanguageServiceService } from './services/language-service.service';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import localeAr from '@angular/common/locales/ar-AE';
import { LoadingComponent } from './shared/loading/loading.component';
import { MatPaginatorModule } from '@angular/material/paginator';

import { HashLocationStrategy, LocationStrategy } from '@angular/common';
import { NodataComponent } from './shared/nodata/nodata.component';
import { ForgetPasswordComponent } from './components/Authentication/forget-password/forget-password.component';
import {MatInputModule} from '@angular/material/input';
import {MatSelectModule} from '@angular/material/select';
import {MatFormFieldModule} from '@angular/material/form-field';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
// or
import { NoopAnimationsModule } from '@angular/platform-browser/animations';
import { ChangePasswordComponent } from './components/Authentication/change-password/change-password.component';
import { MatTableModule } from '@angular/material/table';
import { AllusersComponent } from './components/core/allusers/allusers.component';

import { WelcomeComponent } from './components/core/welcome/welcome.component';

import { AllusersmobileComponent } from './components/core/allusersmobile/allusersmobile.component';

import { MatCheckboxModule } from '@angular/material/checkbox';

import { ServiceWorkerModule } from '@angular/service-worker';

import { MyclientspageComponent } from './components/core/clients manager/myclientspage/myclientspage.component';

import { AddemployeeComponent } from './components/core/Employees Manager/addemployee/addemployee.component';
import { AllemployeesComponent } from './components/core/Employees Manager/allemployees/allemployees.component';
import { EmployeeComponent } from './components/core/Employees Manager/employee/employee.component';

import { EmployeepagemobileComponent } from './components/core/Employees Manager/employeepagemobile/employeepagemobile.component';
import { DailyexpensespageComponent } from './components/core/financial manager/dailyexpensespage/dailyexpensespage.component';
import { ReviewsComponent } from './components/core/website/reviews/reviews.component';
import { EmployeefingerprintComponent } from './components/core/Employees Manager/employeefingerprint/employeefingerprint.component';
import { MatIconModule } from '@angular/material/icon';
import { CreateclientComponent } from './components/core/clients manager/createclient/createclient.component';
import { MyComplexRequestComponent } from './components/core/clients manager/my-complex-request/my-complex-request.component';
import { CreateComplexRequestComponent } from './components/core/clients manager/create-complex-request/create-complex-request.component';
import { ZXingScannerModule } from '@zxing/ngx-scanner';
import { CreatedoctorComponent } from './components/core/doctors/createdoctor/createdoctor.component';
import { AlldoctorsComponent } from './components/core/doctors/alldoctors/alldoctors.component';
import { CreateflyclientComponent } from './components/core/fly/createflyclient/createflyclient.component';
import { AllflyclientesComponent } from './components/core/fly/allflyclientes/allflyclientes.component';
import { CreatedataflowclientComponent } from './components/core/dataflow/createdataflowclient/createdataflowclient.component';
import { AlldataflowclientComponent } from './components/core/dataflow/alldataflowclient/alldataflowclient.component';
import { AllpricelistComponent } from './components/core/price list/allpricelist/allpricelist.component';
import { CreatepriceComponent } from './components/core/price list/createprice/createprice.component';
import { CreatevisaclientComponent } from './components/core/visa clients/createvisaclient/createvisaclient.component';
import { AllvisaclientsComponent } from './components/core/visa clients/allvisaclients/allvisaclients.component';
import { AllcompaniesComponent } from './components/core/companies/allcompanies/allcompanies.component';
import { CreatecompanyComponent } from './components/core/companies/createcompany/createcompany.component';
import { AlljobsComponent } from './components/core/alljobs/alljobs/alljobs.component';
import { CreatejobComponent } from './components/core/alljobs/createjob/createjob.component';
import { ContactUsComponent } from './components/core/contact-us/contact-us.component';
import { DentistformComponent } from './components/core/forms/dentistform/dentistform.component';
import { AllappsComponent } from './allapps/allapps.component';
import { AnalyticsComponent } from './analytics/analytics.component';
import { AppsComponent } from './components/core/apps/apps.component';
import { DentistComponent } from './components/core/dentist/dentist.component';
import { AlldentistComponent } from './components/core/doctors/alldentist/alldentist.component';
import { NotificationsComponent } from './components/core/websitecontentmanager/notifications/notifications.component';
import { JobListComponent } from './components/core/ahmedelshahatjobs/jobs/job-list/job-list.component';
import { CreateJobComponent } from './components/core/ahmedelshahatjobs/jobs/create-job/create-job.component';
import { AddSkillsComponent } from './components/core/ahmedelshahatjobs/skills/add-skills/add-skills.component';
import { CountryandcityComponent } from './components/core/ahmedelshahatjobs/countryandcity/countryandcity/countryandcity.component';
import { ApplyComponent } from './components/core/ahmedelshahatjobs/apply/apply.component';
import { AllblogsComponent } from './components/core/website/allblogs/allblogs.component';
import { CreateblogComponent } from './components/core/website/createblog/createblog.component';
import { ConversationComponent } from './components/core/website/conversation/conversation.component';
import { QuickrepliesmanagementComponent } from './components/core/website/quickrepliesmanagement/quickrepliesmanagement.component';
import { AllchatsComponent } from './components/core/website/allchats/allchats.component';
// import { registerLocaleData } from '@angular/common';

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

// registerLocaleData(localeAr);
@NgModule({
  declarations: [
    AppComponent,
    AllchatsComponent,
AllblogsComponent,
CreateblogComponent,
    LoginComponent,
ReviewsComponent,
    ProfileComponent,
    ResigteringComponent,
    HeaderComponent,
    FooterComponent,
    HeaderMobileComponent,
    VerificationCodeComponent,
    LoadingComponent,
    WelcomeComponent,

    NodataComponent,
    ForgetPasswordComponent,
    ChangePasswordComponent,
    AllusersComponent,
    NotificationsComponent,
    AllusersmobileComponent,

    MyclientspageComponent,
    ContactUsComponent,
    AddemployeeComponent,
    AllemployeesComponent,
    EmployeeComponent,

    EmployeepagemobileComponent,
    DailyexpensespageComponent,

    EmployeefingerprintComponent,
    CreateclientComponent,
    MyComplexRequestComponent,
    CreateComplexRequestComponent,
    CreatedoctorComponent,
    AlldoctorsComponent,
    CreateflyclientComponent,
    AllflyclientesComponent,
    CreatedataflowclientComponent,
    AlldataflowclientComponent,
    AllpricelistComponent,
    CreatepriceComponent,
    CreatevisaclientComponent,
    AllvisaclientsComponent,
    AllcompaniesComponent,
    CreatecompanyComponent,

    CreatejobComponent,
    AlljobsComponent,
    DentistformComponent,
    AllappsComponent,
    AnalyticsComponent,
    AppsComponent,
    DentistComponent,
    AlldentistComponent,
    JobListComponent,
    ApplyComponent,
    CreateJobComponent,
    AddSkillsComponent,
    CountryandcityComponent,
    ConversationComponent,
    QuickrepliesmanagementComponent,
  ],
  imports: [
    BrowserModule,
    MatPaginatorModule,
    AppRoutingModule,
    FormsModule,
    MatFormFieldModule,
    MatCheckboxModule ,
    MatSelectModule,
    MatInputModule,
    ReactiveFormsModule,
    
    HttpClientModule,
    MatTableModule,
    MatIconModule,
        ZXingScannerModule,
    BrowserAnimationsModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: !isDevMode(),
      // Register the ServiceWorker as soon as the application is stable
      // or after 30 seconds (whichever comes first).
      registrationStrategy: 'registerWhenStable:30000'
    }),
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true,
    },
    {
      provide: LOCALE_ID,
      useValue: 'en-US',
    },
   // { provide: LocationStrategy, useClass: HashLocationStrategy },
    LanguageServiceService,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
